// extracted by mini-css-extract-plugin
export default {"index":"index--tz9yw"};